// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.correctAnswerCard{
    background-color: #eafff0;
    border-color: #a2ffbb;
    margin-bottom: 16px;
}
.wrongAnswerCard{
    background-color: #ffeaea;
    border-color: #ffa2a2;
    margin-bottom: 16px;
}
/* styles.css */
.radio-red .ant-radio-inner {
    border-color: red;
  }
  
  .radio-red .ant-radio-inner::after {
    background-color: red;
  }
  
  .radio-green .ant-radio-inner {
    border-color: green !important;
    background: green;
  }
  
  .radio-green .ant-radio-inner::after {
    background-color: green !important;
  }
  
  .radio-green .ant-radio-checked .ant-radio-inner {
    border-color: green;
    background-color: green;
  }
  .radio-incorrect .ant-radio-checked .ant-radio-inner {
    border-color: red;
    background-color: red;
  }
  .reviewModuleMainDiv .radio-green:hover .ant-radio-inner {
    border-color: green;
}
  .reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {
    border-color: red !important;
}
  .radio-correct {
    color: green;
  }
.reviewModuleMainDiv .ant-radio-wrapper{
    cursor: default;
}
.reviewModuleMainDiv .ant-space{
    width: 100%;
}
.reviewModuleMainDiv .ant-radio-group{
    width: 100%;
}
.reviewModuleMainDiv .radio-incorrect{
    width: 100%;
    background: #ff7c7c;
    padding: 10px;
    border-radius: 10px;
}
.reviewModuleMainDiv .radio-green{
    width: 100%;
    background: #5bc740;
    padding: 10px;
    border-radius: 10px;
}
.reviewModuleMainDiv .ant-radio-wrapper{
    width: 100%;
    padding: 10px;
    border-radius: 10px;
}
.correctAnswerResultType{
    float: right;
    border: 1px solid #5bc740;
    border-radius: 25px;
    padding: 5px 7px;
    width: 150px;
    text-align: center;
    color: #5bc740;
    cursor: default;
}
.wrongAnswerResultType{
    float: right;
    border: 1px solid #ff7c7c;
    border-radius: 25px;
    padding: 5px 7px;
    width: 150px;
    text-align: center;
    color: #ff7c7c;
    cursor: default;
}
.DashboardButton{
    margin-bottom: 20px;
    position: relative;
    left: 45%;
}
.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: #c1c1c1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/MCQ/ReviewAnswerModule/ReviewAnswerModule.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,eAAe;AACf;IACI,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,mBAAmB;AACvB;EACE;IACE,4BAA4B;AAChC;EACE;IACE,YAAY;EACd;AACF;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".correctAnswerCard{\r\n    background-color: #eafff0;\r\n    border-color: #a2ffbb;\r\n    margin-bottom: 16px;\r\n}\r\n.wrongAnswerCard{\r\n    background-color: #ffeaea;\r\n    border-color: #ffa2a2;\r\n    margin-bottom: 16px;\r\n}\r\n/* styles.css */\r\n.radio-red .ant-radio-inner {\r\n    border-color: red;\r\n  }\r\n  \r\n  .radio-red .ant-radio-inner::after {\r\n    background-color: red;\r\n  }\r\n  \r\n  .radio-green .ant-radio-inner {\r\n    border-color: green !important;\r\n    background: green;\r\n  }\r\n  \r\n  .radio-green .ant-radio-inner::after {\r\n    background-color: green !important;\r\n  }\r\n  \r\n  .radio-green .ant-radio-checked .ant-radio-inner {\r\n    border-color: green;\r\n    background-color: green;\r\n  }\r\n  .radio-incorrect .ant-radio-checked .ant-radio-inner {\r\n    border-color: red;\r\n    background-color: red;\r\n  }\r\n  .reviewModuleMainDiv .radio-green:hover .ant-radio-inner {\r\n    border-color: green;\r\n}\r\n  .reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {\r\n    border-color: red !important;\r\n}\r\n  .radio-correct {\r\n    color: green;\r\n  }\r\n.reviewModuleMainDiv .ant-radio-wrapper{\r\n    cursor: default;\r\n}\r\n.reviewModuleMainDiv .ant-space{\r\n    width: 100%;\r\n}\r\n.reviewModuleMainDiv .ant-radio-group{\r\n    width: 100%;\r\n}\r\n.reviewModuleMainDiv .radio-incorrect{\r\n    width: 100%;\r\n    background: #ff7c7c;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n.reviewModuleMainDiv .radio-green{\r\n    width: 100%;\r\n    background: #5bc740;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n.reviewModuleMainDiv .ant-radio-wrapper{\r\n    width: 100%;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n.correctAnswerResultType{\r\n    float: right;\r\n    border: 1px solid #5bc740;\r\n    border-radius: 25px;\r\n    padding: 5px 7px;\r\n    width: 150px;\r\n    text-align: center;\r\n    color: #5bc740;\r\n    cursor: default;\r\n}\r\n.wrongAnswerResultType{\r\n    float: right;\r\n    border: 1px solid #ff7c7c;\r\n    border-radius: 25px;\r\n    padding: 5px 7px;\r\n    width: 150px;\r\n    text-align: center;\r\n    color: #ff7c7c;\r\n    cursor: default;\r\n}\r\n.DashboardButton{\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n    left: 45%;\r\n}\r\n.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {\r\n    border-color: #c1c1c1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
